import { makeStyles } from '@material-ui/core';

import IconButton from '@mui/material/IconButton';
import Loader, { linearProgressClasses } from '@mui/material/LinearProgress';
import CheckIcon from 'shared/icons/Check';
import CloseIcon from 'shared/icons/Close';
import styled from 'shared/utils/styled';

export const StyledIconButton = styled(IconButton)(() => ({
  position: 'absolute',
  top: 14,
  right: 10,
  padding: 2,
  background: 'transparent',
}));

export const StyledCloseIcon = styled(CloseIcon)(({ theme }) => ({
  fontSize: '1.3rem',
  color: theme.palette.secondary.main,
  cursor: 'pointer',
}));

export const StyledCheckIcon = styled(CheckIcon)(() => ({
  fontSize: '2.5rem',
  color: '#fff',
}));

export const StyledLoader = styled(Loader)(() => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  [`& .${linearProgressClasses.barColorPrimary}`]: {
    background: '#fff',
  },
}));

export const Container = styled('div')(() => ({
  position: 'relative',
  maxWidth: '25rem',
  padding: '30px 15px',
  background: '#fff',
  borderRadius: 2,
  boxShadow: '0 3px 15px -1px rgba(0,0,0,.5)',
}));

export const Title = styled('h2')(() => ({
  margin: 0,
  paddingTop: '1rem',
  paddingBottom: '1rem',
  fontSize: '2rem',
  fontWeight: 300,
  lineHeight: 1.1,
  color: '#fff',
}));

type DescriptionAccessories = Partial<{
  error: boolean;
}>;

export const Description = styled('p', {
  shouldForwardProp: (prop) => prop !== 'error',
})<DescriptionAccessories>(({ theme, error = false }) => ({
  fontSize: theme.typography.pxToRem(16),
  color: '#666',
  ...(error && {
    color: theme.palette.error.main,
  }),
}));

export const Label = styled('span')(() => ({
  fontSize: 15,
  fontFamily: 'NeoSansStd',
}));

export const CheckIconWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 60,
  height: 60,
  background: theme.palette.primary.main,
  borderRadius: '50%',
}));

export const SuccessTitle = styled('p')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(19),
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

export const SuccessLabel = styled('p')(() => ({
  margin: '5px 0 20px',
  fontSize: 17,
  fontWeight: 400,
  color: '#454545',

  whiteSpace: 'pre-wrap',
}));
